import React from 'react';
import { Link, Typography, Alert } from '@one-thd/sui-atomic-components';
import { UserDetailsSection } from './steps/user-details-section';
import { UserTypeSection } from './steps/user-type-section';
import { scrollToTop } from '../../../utils/general';
import { PaymentPermissionsSection } from './steps/payment-permissions-section';
import { FooterButtons } from './footer-buttons';
import { useManageUserForm } from '../../../hooks/use-manage-user-form';
import { ERR_UNABLE_TO_ADD_OR_EDIT_USER } from '../../../constants/response-error-messages';
var AddUserFormContent = function (_a) {
    var onCancel = _a.onCancel, isAddUserError = _a.isAddUserError;
    var _b = useManageUserForm(), steps = _b.steps, dispatch = _b.dispatch;
    var userDetailsStep = steps[0], userTypeStep = steps[1], paymentPermissionsStep = steps[2], reviewStep = steps[3];
    return (React.createElement("div", { className: "sui-col-span-12 md:sui-col-span-6 2xl:sui-col-span-4" },
        React.createElement("div", { className: "sui-mb-6 sui-flex sui-flex-row sui-justify-between sui-items-baseline" },
            React.createElement(Typography, { variant: "h2" }, "Add User"),
            React.createElement(Link, { "data-testid": "header-cancel-btn", onClick: onCancel }, "Cancel")),
        userDetailsStep.state !== 'HIDDEN' && (React.createElement(UserDetailsSection, { isActive: userDetailsStep.state === 'ACTIVE', isCompleted: userDetailsStep.state === 'COMPLETED', continueHandler: function () {
                dispatch({
                    type: 'COMPLETE',
                    target: 'USER_DETAILS',
                });
            }, editHandler: function () {
                dispatch({
                    type: 'ACTIVATE',
                    target: 'USER_DETAILS',
                });
                dispatch({
                    type: 'DEACTIVATE',
                    target: 'REVIEW',
                });
            }, cancelHandler: function () {
                onCancel();
            } })),
        userTypeStep.state !== 'HIDDEN' && (React.createElement(React.Fragment, null,
            React.createElement("hr", { className: "sui-h-px sui-bg-gray-200 sui-border-1" }),
            React.createElement(UserTypeSection, { isActive: userTypeStep.state === 'ACTIVE', isCompleted: userTypeStep.state === 'COMPLETED', shouldDisableEditing: paymentPermissionsStep.state === 'ACTIVE', continueHandler: function () {
                    scrollToTop();
                    dispatch({
                        type: 'COMPLETE',
                        target: 'USER_TYPE',
                    });
                }, editHandler: function () {
                    dispatch({
                        type: 'ACTIVATE',
                        target: 'USER_TYPE',
                    });
                    dispatch({
                        type: 'DEACTIVATE',
                        target: 'REVIEW',
                    });
                }, cancelHandler: function () {
                    onCancel();
                } }))),
        paymentPermissionsStep.state !== 'HIDDEN' && (React.createElement(React.Fragment, null,
            React.createElement("hr", { className: "sui-h-px sui-bg-gray-200 sui-border-1" }),
            React.createElement(PaymentPermissionsSection, { isActive: paymentPermissionsStep.state === 'ACTIVE', isCompleted: paymentPermissionsStep.state === 'COMPLETED', shouldDisableEditing: userTypeStep.state === 'ACTIVE', continueHandler: function () {
                    return dispatch({
                        type: 'COMPLETE',
                        target: 'PAYMENT_PERMISSIONS',
                    });
                }, editHandler: function () {
                    dispatch({
                        type: 'ACTIVATE',
                        target: 'PAYMENT_PERMISSIONS',
                    });
                    dispatch({
                        type: 'DEACTIVATE',
                        target: 'REVIEW',
                    });
                }, cancelHandler: function () {
                    onCancel();
                } }))),
        isAddUserError && (React.createElement("div", { "data-testid": "select-pha-drawer-alert" },
            React.createElement(Alert, { status: "error" }, ERR_UNABLE_TO_ADD_OR_EDIT_USER.message))),
        reviewStep.state === 'ACTIVE' && (React.createElement("div", { className: "sui-pt-8" },
            React.createElement(FooterButtons, { continueText: "Add User", type: "submit", cancelHandler: onCancel })))));
};
AddUserFormContent.displayName = 'AddUserFormContent';
export default AddUserFormContent;
